import { gql } from "apollo-boost";

const QUERY = gql`
  query UserDetails($userId: ID!) {
    portalUser(id: $userId) {
      email
      phone_number
      first_name
      last_name
      application_status
      dob
      type
      completion_status
      last_activity_at
      total_spend
      alloy_link
      galileo_prn
      is_student
      ssn_last_four
      tags
      metadata
      credit {
        credit_limit
        credit_used
        limit_increase {
          eligible
          reason
          last_request
          last_increase
          last_request_event {
            active
            reason
            employed
            employmentDetail
            income
            rent
            desiredLimit
            social
            additionalAccountsAdded
          }
        }
      }
      card {
        status
        activated
        metadata
        last_four_digits
      }
      transactions {
        id
        description
        amount
        created_at
        settled_at
        status
        disputed
        dispute_status
        dispute_resolved
        tags
      }
      payments {
        id
        amount
        created_at
        settled_at
        returned_at
        status
        category
        payment_method_id
        ach_return_code
      }
      scheduledPayments {
        uuid
        amount
        scheduled_date
        created_at
        processed_at
        status
        payment_method_id
        created_by
        revised
      }
      asset_report {
        report {
          date_generated
          days_requested
          items {
            accounts {
              name
              owners
              account_id
              type
              subtype
              balances {
                current
              }
              historical_balances {
                current
                date
              }
            }
          }
        }
      }
      transaction_report
      derived_financial_data {
        currentBalance
        otherCredit
        otherCreditCard
        minCreditCardLimit
        oldestBankAge
      }
      bank_accounts {
        account_id
        finicity_account_id
        name
        type
        aggregatorType
        institution
        lastFour
        status
        accountNumber
        routingNumber
        payment_method_id
        mask
        balances {
          available_balance
          current_balance
          created_at
        }
        averageBalance
        newlyAdded
        payment_method_id
        unlinked
      }
      default_payment_method {
        plaid_account_id
        finicity_account_id
        unlinked
        id
      }
      payment_methods {
        plaid_account_id
        finicity_account_id
        account_number_last_four
        institution
        nickname
        type
        uuid
        id
      }
      id
      notes {
        id
        agent_name
        agent_id
        body
        body_text
        tags
        created_at
      }
      ip_addresses {
        ip_address
        session_id
        created_at
        updated_at
        browser
        os
        device_type
        city
        subdivisions
        postal
        country
      }
      underwritingDecisionReport
      autopay_day
      products
    }
  }
`;

export default QUERY;
